// window.addEventListener("DOMContentLoaded", () => {
//     gsap.registerPlugin(ScrollTrigger);

//     gsap.from("#difference-details .details-grid-header", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#difference-details .details-grid-header",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#signature-octagonal .bottom_text", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#signature-octagonal .bottom_text",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#signature-octagonal .top_text", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#signature-octagonal .top_text",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#layers-nexora-os .top-content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#layers-nexora-os",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#nexora-compares .os-comparison__heading", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#nexora-compares .os-comparison__heading",
//             start: "top 70%",
//             end: "top 30%",
//             scrub: true,
//         },
//     });

//     gsap.from("#canvas-ai .nexora_banner_content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#canvas-ai .nexora_banner_content",
//             start: "top 70%",
//             end: "top 30%",
//             scrub: true,
//         },
//     });

//     gsap.from("#layers-ai .top-content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#layers-ai",
//             start: "top 70%",
//             end: "top 30%",
//             scrub: true,
//         },
//     });

//     gsap.from("#gps-fitness .top-content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#gps-fitness",
//             start: "center 90%",
//             end: "center 50%",
//             scrub: true,
//         },
//     });

//     gsap.from("#workout-AOD .image-with-text__content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#workout-AOD",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#built-for-game .watch-heading-title", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#built-for-game",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });
 
//     gsap.from("#activity-rings .image-with-text-top", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#activity-rings",
//             start: "top 70%",
//             end: "top 30%",
//             scrub: true,
//         },
//     });

//     gsap.from("#accurate-health-data .image-with-text__text-item.grid__item", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#accurate-health-data",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#hi-silicon .nexora_banner_content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#hi-silicon",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#seven-days-battery .image-with-text__text-item", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#seven-days-battery",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#unique-watch-faces .watch-content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#unique-watch-faces",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#bluetooth-calling .top-content", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#bluetooth-calling",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#four-new-addition .watch-heading", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#four-new-addition",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#app-showcase .content-wrapper", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#app-showcase",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#comparison-table .image-with-text__text-item", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#comparison-table",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     gsap.from("#nexora-pdp-faq .faq-left", {
//         opacity: 0,
//         y: 40,
//         scrollTrigger: {
//             trigger: "#comparison-table",
//             start: "top 70%",
//             end: "top 20%",
//             scrub: true,
//         },
//     });

//     setTimeout(() => {
//         ScrollTrigger.refresh();
//     }, 2000);
// });

gsap.registerPlugin(ScrollTrigger);

const targets = [
  // "#difference-details .details-grid-header",
  // "#signature-octagonal .bottom_text",
  // "#signature-octagonal .top_text",
  "#layers-nexora-os .top-content",
  // "#nexora-compares .os-comparison__heading",
  // "#canvas-ai .nexora_banner_content",
  // "#layers-ai .top-content",
  // "#bright-enough-display .top-content",
  // "#bright-enough-display .nexora_bottom_content_wrapper",
  // "#gps-fitness .top-content",
  // "#gps-fitness .nexora_bottom_content_inner.block_text-block",
  // "#workout-AOD .image-with-text__content",
  // "#built-for-game .watch-heading-title",
  // "#activity-rings .image-with-text-top",
  // "#accurate-health-data .image-with-text__text-item.grid__item",
  // "#hi-silicon .nexora_banner_content",
  // "#seven-days-battery .image-with-text__text-item",
  // "#unique-watch-faces .watch-content",
  // "#bluetooth-calling .top-content",
  // "#four-new-addition .watch-heading",
  // "#app-showcase .content-wrapper",
  // "#comparison-table .image-with-text__text-item",
  // "#nexora-pdp-faq .faq-left",
];

if (window.matchMedia("(max-width: 749px)").matches) {
  const reveal = (el) => {
    gsap.fromTo(
      el,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top 70%",
          end: "top 20%",
          scrub: true,
          invalidateOnRefresh: true,
          // markers: true,
        },
      }
    );
  };

  const mm = gsap.matchMedia();

  mm.add("(min-width: 1px)", () => {
    targets.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (el.offsetParent === null) return;
        reveal(el);
      });
    });
  });
}

window.addEventListener("load", () => ScrollTrigger.refresh());

document.querySelectorAll("img").forEach((img) => {
  if (!img.complete) {
    img.addEventListener("load", () => ScrollTrigger.refresh(), {
      once: true,
    });
  }
});

document.fonts?.ready.then(() => ScrollTrigger.refresh());

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-icon-text-block').forEach(function (block) {
    const secondChild = block.children[1];

    if (secondChild) {
      secondChild.style.cursor = 'pointer';

      secondChild.addEventListener('click', function () {
        window.location.href = '/pages/return-cancellation-policy';
      });
    }
  });
});